import { useDispatch, useSelector } from "react-redux";
import * as con from "../../GlobalConstants"
import { setGridState } from "../../store/slices/gridSlice";




/**
 * Hook for a single Grid Strategy in the store read only
 */
export function RefGridStrategyHook(parameterName) {

    const value = useSelector(state => state[con.REDUCER_GRID_STRATEGY][parameterName])

    return(value);
}


/**
 * Hook for a single Grid Strategy parameter in the store (read & write)
 */
export function StateGridStrategyHook(parameterName) {

  const dispatch = useDispatch();

  const value = useSelector(
    state => state[con.REDUCER_GRID_STRATEGY][parameterName]
  );

  const setParameter = (newVal) => {
    dispatch(
      setGridState({
        id: parameterName,
        value: newVal,
      })
    );
  };

  return [value, setParameter];
}




/**
 * Hook for a single nested Grid Strategy parameter in the store (Read Only)
 */
export function RefNestedGridStrategyHook(parameterName, attributeName) {

  const allValues = useSelector(
    (state) => state[con.REDUCER_APPLICATION_PARAMETERS][parameterName]
  );
  
  const value = allValues?.[attributeName];
  return value;
}


/**
 * Hook for a single nested Grid Strategy parameter in the store
 */
export function StateNestedGridStrategyHook(parameterName, attributeName) {
  const dispatch = useDispatch();

  const allValues = useSelector(
    (state) => state[con.REDUCER_APPLICATION_PARAMETERS][parameterName]
  );

  const value = allValues?.[attributeName];

  const setValue = (newValue) => {
    dispatch(
      setGridState({
        id: parameterName,
        value: {
          ...allValues,
          [attributeName]: newValue,
        },
      })
    );
  };

  return [value, setValue];
}